import React from 'react';
import PropTypes from 'prop-types';
import styles from './Card.module.scss';

/**
 * Card component with bordered/borderless support.
 * @param {object} props
 * @param {boolean} [props.bordered=true] - Show border if true.
 * @param {string} [props.className] - Additional class names.
 * @param {React.ReactNode} props.children - Card content.
 * @param {object} [props.style] - Inline styles.
 */
const Card = ({ bordered = true, className = '',hoverable = false, style = {}, children, ...rest }) => {
  const cardClass = [
    styles.card,
    bordered ? styles.bordered : styles.borderless,
    hoverable ? styles.hoverableCard : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClass} style={style} {...rest}>
      {children}
    </div>
  );
};

Card.propTypes = {
  bordered: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  hoverable: PropTypes.bool
};

export default Card;
